import request from 'crm/utils/request'
import api from 'crm/common/api/group-msg'
import {format} from 'utils'
import qs from 'qs'

// 群发列表
export async function getMsgList(payload) {
    return request(`${format(api.getMsgList.url)}?${qs.stringify(payload.params)}`)
}

// 群发明细列表
export async function getMsgDetails(payload) {
    return request(
        `${format(api.getMsgDetails.url, {id: payload.id})}?${qs.stringify(payload.params)}`,
    )
}

// 创建群发
export async function createMsg(payload) {
    return request(api.createMsg.url, {
        method: api.createMsg.type,
        body: payload.body,
    })
}

// 群发摘要
export async function getMsgSummary(payload) {
    return request(format(api.getMsgSummary.url, {id: payload.id}))
}

// 获取客户管理的客户
export async function getCustomers(params) {
    return request(api.getCustomers.url, {
        method: api.getCustomers.type,
        body: params,
    })
}

// 重发详情
export async function getRepeatDetails(payload) {
    return request(format(api.getRepeatDetails.url, {id: payload.id}))
}

// 取消群发
export async function cancelSendMsg(payload) {
    return request(format(api.cancelSendMsg.url, {id: payload.id}), {
        method: api.cancelSendMsg.type,
        body: payload.body,
    })
}

// 计算过滤后的群发客户数量
export async function getFilterCustomerCount(payload) {
    return request(api.getFilterCustomerCount.url, {
        method: api.getFilterCustomerCount.type,
        body: payload.body,
    })
}
